import {
    Button,
    Container,
    Flashbar,
    Form,
    Header,
    Icon,
    SpaceBetween,
    Spinner,
    TextContent,
} from '@amzn/awsui-components-react';
import { useCreateOPR } from '../../hooks/useCreateOPR';
import { AOCConfig } from '../../service/config';
import { getProvider } from '../../service/providers';
import { OPRFormData } from './CreateOPRForm';
import { useUserProfileTranslation } from '../../hooks/useTranslation';
import { isUnauthorizedError } from '../../utils/errorUtils';

export const createCustomerMessage = (link: string, t: (key: string) => string): string => {
    return `${t('SubmittedOwnershipProofRequest.customerEmailBeforeLink')} ${link} ${t(
        'SubmittedOwnershipProofRequest.customerEmailAfterLink',
    )}`;
};

export const CreateOPRSubmit = ({
    config,
    formData,
    clearForm,
}: {
    config: AOCConfig;
    formData: OPRFormData;
    clearForm: () => void;
}) => {
    const createOPRState = useCreateOPR(config, formData.caseID, formData.accounts);
    const { t } = useUserProfileTranslation();
    const link = `${window.location.href.split('?')[0].replace(/\/?create\/?/, '')}?requestId=${
        createOPRState.requestId as string
    }`;

    return (
        <>
            {createOPRState.loading ? (
                <Spinner data-testid="loading" />
            ) : createOPRState.err ? (
                isUnauthorizedError(createOPRState.err) ? (
                    <Flashbar
                        items={[
                            {
                                header: 'Unauthorized Access',
                                content: 'You do not have the required permissions to access this page.',
                                type: 'error',
                                dismissible: false,
                                id: 'unauthorized',
                            },
                        ]}
                    />
                ) : (
                    <p>An error has occured, please try again</p>
                )
            ) : (
                <Form
                    actions={
                        <Button formAction="submit" variant="primary" onClick={clearForm}>
                            New request
                        </Button>
                    }
                >
                    <Container header={<Header>Request Created</Header>}>
                        <TextContent>
                            <h3>Request Link</h3>
                            <p>Copy this message to send to your customer:</p>
                            <p>
                                <span>
                                    {t('SubmittedOwnershipProofRequest.customerEmailBeforeLink')}{' '}
                                    <a href={link} rel="noopener noreferrer">
                                        {link}
                                    </a>{' '}
                                    {t('SubmittedOwnershipProofRequest.customerEmailAfterLink')}
                                </span>
                                <Button
                                    variant="link"
                                    onClick={() => navigator.clipboard.writeText(createCustomerMessage(link, t))}
                                >
                                    <Icon name="copy" /> Copy message
                                </Button>{' '}
                            </p>
                        </TextContent>
                    </Container>
                    <Container disableHeaderPaddings>
                        <SpaceBetween direction="vertical" size={'s'}>
                            <TextContent>
                                <h3>Case ID</h3>
                                <p>{formData.caseID}</p>
                            </TextContent>
                            {formData.accounts.map((account, index) => {
                                return (
                                    <TextContent key={index}>
                                        <h3>Account {index + 1}</h3>
                                        <p>Email: {account.email}</p>
                                        <p>Sign in method: {getProvider(account.idp).readableName}</p>
                                    </TextContent>
                                );
                            })}
                        </SpaceBetween>
                    </Container>
                </Form>
            )}
        </>
    );
};
